
import React from "react";
import { Helmet } from "react-helmet";
import { BreadcrumbItemType } from "@/components/ui/breadcrumb-list";

interface CountyHeaderProps {
  countyName: string;
}

export function CountyHeader({ countyName }: CountyHeaderProps) {
  return (
    <>
      <Helmet>
        <title>Nursing Homes in {countyName} | Grandpal</title>
        <meta 
          name="description" 
          content={`Find and compare nursing homes in ${countyName}. Get detailed information about facilities, services, and contact details.`}
        />
      </Helmet>

      <div className="bg-grandpal-beige py-12">
        <div className="container">          
          <h1 className="text-4xl font-bold text-center mb-4 mt-6">
            Nursing Homes in {countyName}
          </h1>
          <p className="text-xl text-grandpal-gray text-center mb-8">
            Find the perfect nursing home in {countyName} for your loved ones
          </p>
        </div>
      </div>
    </>
  );
}
